module.exports = __webpack_public_path__ + "img/b-min.9b7fe566.jpg";